const { getElements } = window.BAO.Utils

class ResultsGrid extends window.BAO.CustomElement() {
  constructor () {
    super()

    this.eventBus = window.theme.nosto.eventBus
    this.events = window.theme.results.events
  }

  connectedCallback () {
    super.connectedCallback()
    this.handleProductsUpdated = this.handleProductsUpdated.bind(this)

    this.eventBus.subscribe(
      window.theme.results.events.STATE.PRODUCTS_UPDATED,
      this.handleProductsUpdated,
    )
  }

  disconnectedCallback () {
    this.eventBus.unsubscribe(
      window.theme.results.events.STATE.PRODUCTS_UPDATED,
      this.handleProductsUpdated,
    )
  }

  setupListeners () {
    super.setupListeners()

    this.handleClick.bind(this)
    this.listeners.add(this, 'click', this.handleClick)
  }

  handleProductsUpdated ({ products, interaction, state }) {
    this.updateView(products)

    if (
      interaction === 'initial' ||
      interaction === 'filter' ||
      interaction === 'sort'
    ) {
      const itemEls = getElements('[data-results-grid-el="item"]', {
        context: this.els.resultsProducts.element,
      })

      itemEls.forEach((itemEl) => {
        if (itemEl.dataset.type === 'promo') return
        itemEl.remove()
      })

      products.forEach((product, index) => {
        const listEl = document.createElement('li')
        listEl.id = `product-${product.productId}`
        listEl.classList.add('prd-List_Item')
        listEl.setAttribute('data-results-grid-el', 'item')
        // Needed for collection scroll position
        listEl.setAttribute('data-collection-filters-el', 'item')
        listEl.setAttribute('data-type', 'product')

        listEl.innerHTML = window.templates.ProductCard({
          product,
          index,
          type: this.nostoType,
        })

        this.els.resultsProducts.element.appendChild(listEl)
      })
    }

    if (
      interaction === 'pagination' ||
      interaction === 'paginationNext' ||
      interaction === 'paginationPrevious'
    ) {
      const fragment = document.createDocumentFragment()

      products.forEach((product, index) => {
        const listEl = document.createElement('li')
        listEl.id = `product-${product.productId}`
        listEl.classList.add('prd-List_Item')
        listEl.setAttribute('data-results-grid-el', 'item')
        // Needed for collection scroll position
        listEl.setAttribute('data-collection-filters-el', 'item')
        listEl.setAttribute('data-type', 'product')

        listEl.innerHTML = window.templates.ProductCard({
          product,
          index,
          type: this.nostoType,
        })

        fragment.appendChild(listEl)
      })

      if (interaction === 'paginationPrevious') {
        this.els.resultsProducts.element.prepend(fragment)
      } else {
        this.els.resultsProducts.element.appendChild(fragment)
      }
    }

    const hidePromos =
      state.activeFacets.length || state.pagination.showPreviousButton
    this.els.resultsProducts.element.classList.toggle(
      'prd-List_Items-hidePromos',
      hidePromos,
    )

    document.dispatchEvent(new CustomEvent('checkIsInWishlist'))

    if (window.BAO.MediaBreakpoints.isSm) return

    if (interaction === 'filter' || interaction === 'sort') {
      this.els.productGrid.element.scrollIntoView({ behavior: 'smooth' })
    }
  }

  updateView (products) {
    if (products.length) {
      this.els.noResultsView.element.setAttribute('hidden', '')
      this.els.resultsView.element.removeAttribute('hidden')
      return
    }

    this.els.noResultsView.element.removeAttribute('hidden')
    this.els.resultsView.element.setAttribute('hidden', '')
  }

  handleClick (event) {
    const productCardSelector = '[data-results-grid-el="item"]'
    const productCardEl = event.target.closest(productCardSelector)

    if (!productCardEl) return
    this.handleProductCardClick(event)
  }

  handleProductCardClick (event) {
    const productCard = event.target.closest('product-card')
    const url = productCard.dataset.productUrl || false
    if (!productCard || !url) return

    this.eventBus.publish(this.events.TRACKING.PRODUCT_CLICKED, {
      productId: productCard.dataset.productId,
      productUrl: productCard.dataset.productUrl,
      type: this.nostoType,
    })
  }

  get nostoType () {
    return this.dataset.nostoType || 'category'
  }
}

if (!customElements.get('results-grid')) {
  customElements.define('results-grid', ResultsGrid)
}
